
export default function CertificationSection() {
  return (
    <section className="py-20 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-16">
          <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-4xl font-bold text-[#663333] mb-4">
            权威认证与荣誉
          </h2>
          <p className="text-xs sm:text-sm lg:text-lg text-gray-600 max-w-2xl mx-auto">
            获得多项权威认证，行业专家一致认可的品质保障
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* 质量管理体系认证 */}
          <div className="bg-[#f8f6f3] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
              <i className="ri-award-fill text-lg sm:text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-[#663333] mb-3">ISO 9001认证</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              通过国际质量管理体系认证，确保产品质量管理的标准化和规范化
            </p>
          </div>

          {/* 食品安全管理体系 */}
          <div className="bg-[#f8f6f3] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
              <i className="ri-shield-check-fill text-lg sm:text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-[#663333] mb-3">HACCP认证</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              食品安全管理体系认证，从源头到终端全程食品安全保障
            </p>
          </div>

          {/* 有机产品认证 */}
          <div className="bg-[#f8f6f3] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
              <i className="ri-leaf-fill text-lg sm:text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-[#663333] mb-3">有机认证</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              部分产品获得有机认证，确保从茶园到茶杯的天然纯净品质
            </p>
          </div>

          {/* 地理标志产品 */}
          <div className="bg-[#f8f6f3] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
              <i className="ri-map-pin-fill text-lg sm:text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-[#663333] mb-3">地理标志认证</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              获得普洱茶地理标志产品认证，确保产地的真实性和独特性
            </p>
          </div>

          {/* 绿色食品认证 */}
          <div className="bg-[#f8f6f3] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
              <i className="ri-seedling-fill text-lg sm:text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-[#663333] mb-3">绿色食品认证</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              符合绿色食品标准，保证产品安全、优质、营养的品质特征
            </p>
          </div>

          {/* 出口食品认证 */}
          <div className="bg-[#f8f6f3] rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
              <i className="ri-global-fill text-lg sm:text-xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-[#663333] mb-3">出口认证</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              获得出口食品生产企业备案，产品远销海外多个国家和地区
            </p>
          </div>
        </div>

        {/* 专家评价 */}
        <div className="bg-[#663333] rounded-3xl p-12 text-white">
          <h3 className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold text-center mb-12 text-[#cc9966]">专家评价</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-[#774444] rounded-2xl p-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#cc9966] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-fill text-white text-base sm:text-lg md:text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#cc9966] text-xs sm:text-sm">陈宗懋院士</h4>
                  <p className="text-xs sm:text-sm text-gray-300">中国工程院院士、茶学专家</p>
                </div>
              </div>
              <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                "顺年陈在年份茶标准化建设方面做出了突出贡献，其'三真'体系为行业树立了新的标杆。"
              </p>
            </div>

            <div className="bg-[#774444] rounded-2xl p-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#cc9966] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-fill text-white text-base sm:text-lg md:text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#cc9966] text-xs sm:text-sm">刘仲华教授</h4>
                  <p className="text-xs sm:text-sm text-gray-300">湖南农业大学茶学系教授</p>
                </div>
              </div>
              <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                "顺年陈的科学仓储管理体系，为普洱茶的品质稳定性提供了有力保障，值得行业学习。"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
